import type { DataFileGroup } from "../../types/generated/api/DataFileGroup"
import type { DataFileGroupList } from "../../types/generated/api/DataFileGroupList"

export interface DataFileContainerProps {
  dataFile: DataFileGroupList
}

export interface DataFileCardProps extends DataFileContainerProps {
  onDownloadInitiated: () => void
  menuOptions?: {
    title: string
    variant?: "negative" | "base"
    onClick: () => void
  }[]
}

export type UploadDataFileRequest = {
  project_uuid: string
  file: File
  setProgress?: (progress: number) => void
  signal?: AbortSignal
  type: DataFileGroup.type
  name?: string
}

export type UpdateDataFileRequest = {
  project_uuid: string
  data_file_uuid: string
  file: File
  setProgress?: (progress: number) => void
  signal?: AbortSignal
  name?: string
}

export enum FileTypeEnum {
  GENERIC = "Generic",
  CONDITION_LIST = "Condition list",
  PREDICTIONS = "Predictions",
  SCRIPT = "Script",
  REQUIREMENTS = "Requirements",
  ACTUAL_DECISIONS = "Actual decisions",

  // Export jobs Enum
  MODEL_PREDICTIONS = "Model",
  DEPLOYMENT_PREDICTIONS = "Live",
  SIMULATION_PREDICTIONS = "Simulation",
  WORKFLOW_PREDICTIONS = "Workflow",
}

export enum FileTypeColorMap {
  GENERIC = "blue",
  CONDITION_LIST = "orange",
  PREDICTIONS = "pink",
  ACTUAL_DECISIONS = "purple",

  // Export jobs Enum
  MODEL_PREDICTIONS = "blue",
  DEPLOYMENT_PREDICTIONS = "orange",
  SIMULATION_PREDICTIONS = "pink",
  WORKFLOW_PREDICTIONS = "purple",
}
